module.exports = __webpack_public_path__ + "img/1x.beba91b.jpg";